import axios from "axios";

export function getStudentListAttendance(co) {
  const config = {
    params: co,
  };
  return axios.get(process.env.VUE_APP_API_URL + "Attendance/classdayandtimestudent", config);
}

export function getAttendanceListByStudent() {
  return axios.get(process.env.VUE_APP_API_URL + "Attendance/studentAttendance");
}

export function postAttendance(data) {
  return axios.post(process.env.VUE_APP_API_URL + "Attendance/add", data);
}

export function postAttendanceMore(data) {
  return axios.post(process.env.VUE_APP_API_URL + "Attendance/AddMore", data);
}

export function updateAttendance(data) {
  return axios.put(process.env.VUE_APP_API_URL + "Attendance/update", data);
}

export function deleteAttendance(attendanceId) {
  const config = {
    params: {
      attendanceId: attendanceId,
    },
  };

  return axios.delete(process.env.VUE_APP_API_URL + "Attendance/deleted", config);
}
